import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';
import { theme } from '@garnish/constants';
import { BodyText, FadeView, LoadingDots, TextLink } from '@sg/garnish';

export const OrderStatusCancellationOption = (
  props: OrderStatusCancellationOptionProps,
) => {
  const { onContactUs, isLoading = false } = props;
  const { formatMessage } = useIntl();

  const label = formatMessage(messages.cancellationOption);
  const highlight = formatMessage(messages.cancellationHighlight);

  return (
    <View style={styles.optionContainer}>
      <BodyText size={3}>
        <Text>{label}</Text>
        <TextLink onPress={onContactUs}>{highlight}</TextLink>
      </BodyText>

      <FadeView show={isLoading} style={styles.loadingIcon}>
        <LoadingDots />
      </FadeView>
    </View>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  optionContainer: {
    flexDirection: 'row',
    marginTop: theme.spacing['4'],
  },
  loadingIcon: {
    marginLeft: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

export type OrderStatusCancellationOptionProps = {
  onContactUs: () => void;
  isLoading?: boolean;
};

// ─── Messages ──────────────────────────────────────────────────────────────────

const messages = defineMessages({
  cancellationOption: {
    defaultMessage: 'Need to cancel your order? ',
    description:
      'Order Status | Order Status Cancellation Card | Cancellation cta',
  },
  cancellationHighlight: {
    defaultMessage: 'Contact us',
    description:
      'Order Status | Order Status Cancellation Card | Contact us cta',
  },
});
